import React from 'react';
import { HtmlTooltip } from './HtmlTootip';
import InfoIcon from '@mui/icons-material/Info';

function HtmlTootipInfo({ message, width = 24, height = 24 }) {
  return (
    <HtmlTooltip
      title={message}
      placement="right"
      arrow
      interactive
    >
      <InfoIcon
        sx={{ width, height }}
        color="primary"
        fontSize="inherit"
      />
    </HtmlTooltip>
  );
}

export default HtmlTootipInfo;
